import CheckCircle from "../../icons/CheckCircle";
import CheckCircleFilled from "../../icons/CheckCircleFilled";
import styles from './styles.module.css'

function JourneyListItem({status, journey, isHindi}){
    return (
        <a
            href={`/wellbeing?ic=${journey.content.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.LinkStyle} 
        >
        <div className={styles.JourneyParent}>
            <div className={styles.ListParent}>
                <div>
                    {/* status */}
                    {!status ? <CheckCircle /> : <CheckCircleFilled />}
                </div> 
                <div className = {styles.JourneyTitle}>
                    {/* title */}
                    
                    {journey.title}
                    
                </div>
            </div>
            <div className={styles.ListPromo}>
                {journey.content.promo_text}
            </div>
            <div className={styles.ListPromo}>
                {isHindi ? "इंटरऐक्टिव" : "Interactive"} | {journey.content.duration} {isHindi ? "मिनट" : "minutes"}
            </div>
        </div>
        </a>
    )
}

export default JourneyListItem